import Vue from "vue";
import { Button } from "element-ui";
import { Dialog } from "element-ui";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { Pagination } from "element-ui";
import { Menu, Submenu, MenuItem } from "element-ui";
import { Input } from "element-ui";
import { Checkbox } from "element-ui";
import { Switch } from "element-ui";
import { Select, Option } from "element-ui";
import { Table, TableColumn } from "element-ui";
import { DatePicker, TimeSelect, TimePicker } from "element-ui";
import { Tooltip } from "element-ui";
import { Form, FormItem } from "element-ui";
import { Tree } from "element-ui";
import { Icon } from "element-ui";
import { Row, Col } from "element-ui";
import { Upload } from "element-ui";
import { Divider } from "element-ui";
import { PageHeader } from "element-ui";

import { MessageBox } from "element-ui";
import { Notification } from "element-ui";

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Dropdown).use(DropdownMenu).use(DropdownItem);
Vue.use(Pagination);
Vue.use(Menu).use(Submenu).use(MenuItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Switch);
Vue.use(Select).use(Option);
Vue.use(Table).use(TableColumn);
Vue.use(DatePicker).use(TimeSelect).use(TimePicker);
Vue.use(Tooltip);
Vue.use(Form).use(FormItem);
Vue.use(Tree);
Vue.use(Icon);
Vue.use(Row).use(Col);
Vue.use(Upload);
Vue.use(Divider);
Vue.use(PageHeader);

Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
